const initialState = () => ({
  users: [],
})

const getters = {
  USERS: state => state.users,
}

const actions = {}

const mutations = {
  RESET_STATE (state, payload) {
    const s = initialState()
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  SET_USERS (state, payload) {
      state.users = payload
    },
}

export default {
  namespaced: true,
  state: initialState(),
  getters,
  actions,
  mutations,
}
